import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import UINotificationServiceType from '../../../../core/src/services/UINotificationService';
import './ViewportOverlay.css';

// The overlay-top and overlay-bottom classes are explicitly needed to offset
// the overlays (i.e. via absolute positioning) such the ViewportActionCorners
// have space for its child components.
// ToDo: offset the ViewportOverlay automatically via css to account for the
// space needed for ViewportActionCorners.
const classes = {
  topLeft: 'overlay-top left-viewport',
  topRight: 'overlay-top right-viewport-scrollbar',
  bottomRight: 'overlay-bottom right-viewport-scrollbar',
  bottomLeft: 'overlay-bottom left-viewport',
};

export type ViewportOverlayProps = {
  topLeft: React.ReactNode;
  topRight: React.ReactNode;
  bottomRight: React.ReactNode;
  bottomLeft: React.ReactNode;
  color?: string;
  uiNotificationService?: UINotificationServiceType;
};

const ViewportOverlay = ({
  topLeft,
  topRight,
  bottomRight,
  bottomLeft,
  uiNotificationService,
  color = 'text-primary-light',
}: ViewportOverlayProps) => {
  const [textRender, setTextRender] = useState(
    uiNotificationService ? uiNotificationService.getTextRenderHandler() : false
  );

  const overlay = 'absolute pointer-events-none viewport-overlay text-white';

  useEffect(() => {
    if (!uiNotificationService) {
      return;
    }

    // Subscribe to changes in the textRender value
    const unsubscribe = uiNotificationService.subscribeToTextRenderChanges(newValue => {
      setTextRender(newValue);
    });

    // Cleanup subscription when component unmounts
    return unsubscribe;
  }, [uiNotificationService]);
  const hiddenText = textRender ? 'text-opacity-0' : '';

  // serviceImplementation
  return (
    <div
      className={classnames(
        color ? color : 'text-aqua-pale',
        'text-[13px]',
        'leading-5',
        'overlay-text'
      )}
    >
      <div
        data-cy={'viewport-overlay-top-left'}
        className={classnames(overlay, classes.topLeft, hiddenText)}
      >
        {topLeft}
      </div>
      <div
        data-cy={'viewport-overlay-top-right'}
        className={classnames(overlay, classes.topRight, hiddenText)}
        style={{ transform: 'translateX(-8px)' }} // shift right side overlays by 4px for better alignment with ViewportActionCorners' icons
      >
        {topRight}
      </div>
      <div
        data-cy={'viewport-overlay-bottom-right'}
        className={classnames(overlay, classes.bottomRight, hiddenText)}
        style={{ transform: 'translateX(-8px)' }} // shift right side overlays by 4px for better alignment with ViewportActionCorners' icons
      >
        {bottomRight}
      </div>
      <div
        data-cy={'viewport-overlay-bottom-left'}
        className={classnames(overlay, classes.bottomLeft, hiddenText)}
      >
        {bottomLeft}
      </div>
    </div>
  );
};

export default ViewportOverlay;
